<template>
  <nav class="bottom-nav">
    <router-link to="/agenda" class="nav-item agenda-item" active-class="active">
      <span class="label">Agenda</span>
    </router-link>
    <router-link to="/pacientes" class="nav-item pacientes-item" active-class="active">
      <span class="label">Pacientes</span>
    </router-link>
    <router-link 
      v-if="usuariosStore.esAdmin" 
      to="/admin" 
      class="nav-item admin-item" 
      active-class="active"
    >
      
      <span class="label">🔒Admin</span>
    </router-link>
    <router-link to="/soporte" class="nav-item soporte-item" active-class="active">
      <span class="label">Soporte</span>
    </router-link>
  </nav>
</template>

<script setup>
import { useUsuariosStore } from "@/stores/usuarios";

const usuariosStore = useUsuariosStore();
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 65px;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* padding-bottom = franja segura del iPhone (barra del "home"): así los botones
     no quedan pegados/tapados abajo. En teléfonos sin esa franja (Android) vale 0. */
  padding: 0 8px env(safe-area-inset-bottom, 0px);
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  font-family: system-ui, sans-serif;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #666;
  padding: 12px 6px;
  transition: all 0.25s ease;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 0 4px;
}

.nav-item .icon {
  font-size: 20px;
  margin-bottom: 2px;
}

.nav-item .label {
  font-size: 12px;
  font-weight: 500;
}

.nav-item:hover {
  background: #678AB2;
  color: white;
  border-color: #678AB2;
}

.nav-item.active {
  background: #678AB2;
  color: white;
  border-color: #678AB2;
}

/* Desktop: texto y barra más grandes */
@media (min-width: 768px) {
  .bottom-nav {
    height: 72px;
    padding: 0 16px env(safe-area-inset-bottom, 0px);
  }

  .nav-item .label {
    font-size: 15px;
    font-weight: 600;
  }

  .nav-item {
    padding: 14px 12px;
    border-radius: 10px;
  }
}

/* ADMIN - Morado para distinguir */
.nav-item.admin-item {
  background: white;
  color: #666;
  border: 1px solid #ddd;
}

.nav-item.admin-item:hover {
  background: #8b5cf6;
  color: white;
  border-color: #8b5cf6;
}

.nav-item.admin-item.active {
  background: #8b5cf6;
  color: white;
  border-color: #8b5cf6;
}
</style>
